import cn from "classnames"
import { Fragment } from "react"

import { Divider, Flex } from "@/atoms"
import { RiskTooltipContent } from "./RiskTooltipContent"

import styles from "./RiskTooltip.module.scss"

import type { MultiVulnerabilityTooltipProps } from "./RiskTooltip.types"

export const MultiVulnerabilityTooltip = (
  props: MultiVulnerabilityTooltipProps
) => {
  const { riskIds, noPublishedOn, onClick, onExternalLinkClick } = props

  return (
    <Flex
      vertical
      gap={12}
      onClick={onClick}
      className={cn(
        styles.scrollable,
        noPublishedOn && styles.scrollableNoPublished
      )}
    >
      {riskIds.map((riskId, index) => (
        <Fragment key={riskId.id}>
          {index > 0 && <Divider className={styles.divider} />}
          <Flex vertical gap={16} className={styles.item}>
            <div>
              <RiskTooltipContent
                noPublishedOn={noPublishedOn}
                riskId={riskId.id}
                publishedOn={riskId.publishedOn}
                aliases={riskId.aliases}
                onExternalLinkClick={onExternalLinkClick}
              />
            </div>
          </Flex>
        </Fragment>
      ))}
    </Flex>
  )
}
